<template>
  <div>
    <div id="service">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
        <el-breadcrumb-item>配置服务</el-breadcrumb-item>
      </el-breadcrumb>
      <!--<div style="width:100%;height:100%;position: absolute;right:0;top:0;background:red;z-index: 999999">-->
        <!--<iframe src="" id="content_info" width="100%" height="100%" frameborder="0"></iframe>-->
      <!--</div>-->
      <div v-show="open_skill_type != 2">
        <p class="title">配置服务</p>
        <div class="serviceContainer" style="padding:0 30px">
          <div style="padding-top: 10px;">
            <el-form ref="setting" label-width="120px" :rules="settingCheck" :model="settingInfo">
              <el-form-item label="部署地址" prop="endpoint_uri_online">
                <el-input placeholder="请填写技能服务器URL地址" :disabled="local" v-model.trim="settingInfo.endpoint_uri_online" @input.native="changeRoute"></el-input>
              </el-form-item>
              <el-form-item label="授权信息配置">
                <el-switch
                        :disabled="local"
                        :active-value="1"
                        :inactive-value="0"
                        :width="36"
                        v-model="settingInfo.auth_info_set"
                        active-color="#409EFF"
                        inactive-color="#dcdcdc">
                </el-switch>
              </el-form-item>
              <template>
                <div>
                  <div style="margin-top: 20px; height: 200px;">
                    <el-collapse-transition>
                      <div v-show="settingInfo.auth_info_set">
                        <div class="info" style="border-bottom: 1px solid #eee;margin-bottom: 30px;">
                          <el-form-item label="ClientId" prop="resource_client_id">
                            <el-input placeholder="请填写注册应用时获得的API Key" :disabled="local" v-model.trim="settingInfo.resource_client_id" @input.native="changeRoute"></el-input>
                          </el-form-item>
                          <el-form-item label="ClientSecret" prop="resource_client_secret">
                            <el-input placeholder="请填写请求密钥" :disabled="local" v-model.trim="settingInfo.resource_client_secret" @input.native="changeRoute"></el-input>
                          </el-form-item>
                          <el-form-item label="授权地址" prop="login_uri">
                            <el-input placeholder="请填写meatapp上用户授权地址" :disabled="local" v-model.trim="settingInfo.login_uri" @input.native="changeRoute"></el-input>
                          </el-form-item>
                          <el-form-item label="回调地址" prop="redirect_uri">
                            <el-input placeholder="请填写您的回调地址" disabled v-model.trim="settingInfo.redirect_uri" @input.native="changeRoute"></el-input>
                          </el-form-item>
                          <el-form-item label="Token" prop="token">
                            <el-input placeholder="请填写Token地址" :disabled="local" v-model="settingInfo.token"></el-input>
                          </el-form-item>
                          <el-form-item label="Scope" prop="scope">
                            <el-input placeholder="请填写Scope权限,以空格分隔权限列表" :disabled="local" v-model.trim="settingInfo.scope" @input.native="changeRoute"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                    </el-collapse-transition>
                    <el-button class="intentSavebtn" type="primary" :disabled="local" size="mini" round @click="settingService">保 存</el-button>
                  </div>
                </div>
              </template>

            </el-form>
          </div>
        </div>
      </div>
      <div v-show="open_skill_type == 2">
        <p class="title">配置服务</p>
        <div class="serviceContainer" style="padding:0 30px">
          <div style="padding-top: 10px;">
            <el-form ref="setting2" label-width="130px" :rules="settingCheck2" :model="settingInfo2">
              <el-form-item label="部署地址" prop="endpoint_uri_online">
                <el-input placeholder="请填写技能服务器URL地址" :disabled="local" v-model.trim="settingInfo2.endpoint_uri_online" @input.native="changeRoute"></el-input>
              </el-form-item>
              <p class="title_2">授权信息配置</p>
              <template>
                <div>
                  <div style="margin-top: 20px; height: 200px;">
                      <div>
                        <div class="info" id="info" style="border-bottom: 1px solid #eee;margin-bottom: 30px;">
                          <el-form-item label="ResponseType">
                            <el-tooltip content="授权类型遵守OAuth 2.0标准协议，此处的值固定为'code'" placement="top">
                              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                            </el-tooltip>
                            <el-input placeholder="code" disabled value="code"></el-input>
                          </el-form-item>
                          <el-form-item label="ClientId">
                            <el-tooltip content="客户端ID，在注册授权应用时获取的唯一标识" placement="top">
                              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                            </el-tooltip>
                            <el-input placeholder="请填写注册应用时获得的API Key" :disabled="local" v-model.trim="settingInfo2.resource_client_id" @input.native="changeRoute"></el-input>
                          </el-form-item>
                          <el-form-item label="ClientSecret">
                            <el-tooltip content="客户端Secret，在注册应用时获取的密钥" placement="top">
                              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                            </el-tooltip>
                            <el-input placeholder="请填写请求密钥" :disabled="local" v-model.trim="settingInfo2.resource_client_secret" @input.native="changeRoute"></el-input>
                          </el-form-item>
                          <el-form-item label="授权地址" prop="login_uri">
                            <el-tooltip content="技能的的授权地址，授权类型遵守OAuth 2.0标准协议" placement="top">
                              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                            </el-tooltip>
                            <el-input placeholder="请填写meatapp上用户授权地址" :disabled="local" v-model.trim="settingInfo2.login_uri" @input.native="changeRoute"></el-input>
                          </el-form-item>

                          <el-form-item label="回调地址" prop="redirect_uri">
                            <el-tooltip content="重定向URL，由猎户语音平台自动生成唯一地址" placement="top">
                              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                            </el-tooltip>
                            <el-input placeholder="请填写您的回调地址" disabled v-model.trim="settingInfo2.redirect_uri" @input.native="changeRoute"></el-input>
                          </el-form-item>
                          <el-form-item label="Token地址" prop="token">
                            <el-tooltip content="Access Token，遵守OAuth 2.0标准协议" placement="top">
                              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                            </el-tooltip>
                            <el-input placeholder="请填写Token地址" :disabled="local" v-model="settingInfo2.token"></el-input>
                          </el-form-item>
                          <el-form-item label="Scope">
                            <el-tooltip content="以空格分割的权限列表，若不传递此参数，代表请求用户的默认权限" placement="top">
                              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                            </el-tooltip>
                            <el-input placeholder="请填写Scope权限,以空格分隔权限列表" :disabled="local" v-model.trim="settingInfo2.scope" @input.native="changeRoute"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                  </div>
                </div>
              </template>

            </el-form>
          </div>
        </div>
        <div class="btn_group">
          <el-button class="intentSavebtn" type="primary" :disabled="local" size="mini" round @click="settingService2">保 存</el-button>
          <el-button class="intentSavebtn intentSavebtn2" type="primary" :disabled="dis || local" size="mini" :loading="loadingFlag" round @click="oauth">保存并授权</el-button>
          <!--<span class="remarks"> 授权登陆后，会跳转到空白页面，请自行关闭</span>-->
        </div>
      </div>

    </div>

  </div>
</template>
<script>
    import Vue from "vue";
  import {settingSerApi, skillDetailApi, saveAuthorizationApi, searchAccountInfoApi} from '@/api'
  import qs from 'qs'
  import router from '../../router/index'
  export default {
    data() {
        var check_endpoint_uri_online = (rule, value, callback) => {
            setTimeout(() => {
                var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
                if (value != '') {
                    if (!reg.test(value)) {
                        callback(new Error('请输入正确的URL地址'));
                    } else {
                        callback();
                    }
                }
            }, 100);
        }
        var check_login_uri = (rule, value, callback) => {
            setTimeout(() => {
                var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
                if (value != '') {
                    if (!reg.test(value)) {
                        callback(new Error('请填写meatapp上用户授权地址'));
                    } else {
                        callback();
                    }
                }
            }, 100);
        }
        var check_redirect_uri = (rule, value, callback) => {
            setTimeout(() => {
                var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
                if (value != '') {
                    if (!reg.test(value)) {
                        callback(new Error('请填写您的回调地址'));
                    } else {
                        callback();
                    }
                }
            }, 100);
        }
        var check_token = (rule, value, callback) => {
            setTimeout(() => {
                var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
                if (value != '') {
                    if (!reg.test(value)) {
                        callback(new Error('请填写您的回调地址'));
                    } else {
                        callback();
                    }
                }
            }, 100);
        }
      return {
        show3: false,
        settingInfo: {
          skill_id: '',
          endpoint_uri_online: '',
          resource_client_id: '',
          resource_client_secret: '',
          login_uri: '',
          auth_info_set: 0,
          redirect_uri: this.redirectUri(),
          token: '',
          scope: ''
        },
          settingInfo2: {
              skill_id: '',
              endpoint_uri_online: '',
              resource_client_id: '',
              resource_client_secret: '',
              login_uri: '',
              auth_info_set: 0,
              redirect_uri:  this.redirectUri(),
              token: '',
              scope: ''
          },
          open_skill_type: '',
        settingCheck: {
          endpoint_uri_online: [
            { required: true, message: '请输入正确的URL地址', trigger: 'blur'},
            { type: 'url', required: true, message: '请输入正确的URL地址', trigger: 'blur' }
          ],
          resource_client_id: [
            { required: true, message: '请填写注册应用时获得的API Key', trigger: 'blur'},
          ],
          resource_client_secret: [
            { required: true, message: '请填写请求密钥', trigger: 'blur'},
          ],
          login_uri: [
//            { required: true, message: '请输入正确的URL地址', trigger: 'blur'},
            { type: 'url', required: true, message: '请填写meatapp上用户授权地址', trigger: 'blur' }
          ],
          redirect_uri: [
//            { required: true, message: '请输入正确的URL地址', trigger: 'blur'},
            { type: 'url', required: true, message: '请填写您的回调地址', trigger: 'blur' }
          ],
         token: [
           { required: true, message: '请输入正确的URL地址', trigger: 'blur'},
           { type: 'url', required: true, message: '请输入正确的token地址', trigger: 'blur' }
         ],
          scope: [
            { required: true, message: '请填写Scope权限', trigger: 'blur'},
          ],
        },
          settingCheck2: {
              endpoint_uri_online: [
                  {validator: check_endpoint_uri_online, trigger: 'blur'},
              ],
              resource_client_id: [
                  { required: true, message: '请填写注册应用时获得的API Key', trigger: 'blur'},
              ],
              resource_client_secret: [
                  { required: true, message: '请填写请求密钥', trigger: 'blur'},
              ],
              login_uri: [
                  {validator: check_login_uri, trigger: 'blur'},
              ],
              redirect_uri: [
                  {validator: check_redirect_uri, trigger: 'blur'},
              ],
              token: [
                  {validator: check_token, trigger: 'blur'},
              ],
              scope: [
                  { required: true, message: '请填写Scope权限', trigger: 'blur'},
              ],
          },
      local:false,
      loadingFlag: false,
      twoMinutes: null
      }
    },
    created () {
      this.getSkillDetail()
      this.isCanInput()
        this.tabindexNumChange()
//     this.route()
    },
    computed: {
        dis () { //授权 必须所有必填
             if (this.settingInfo2.endpoint_uri_online && this.settingInfo2.resource_client_id && this.settingInfo2.resource_client_secret && this.settingInfo2.login_uri && this.settingInfo2.redirect_uri && this.settingInfo2.token) {
                 return false
             } else {
                 return true
             }
        }
    },
    mounted () {
        $('.icon-wenhao').attr('tabindex',-10)
    },
    methods: {
        redirectUri () {
           return window.location.host.includes('open.ainirobot.com') ? 'https://passport.ainirobot.com:8888/account/third' : window.location.host.includes('opentw.ainirobot.com') ? 'https://jp-passport.ainirobot.com:8888/account/third' : 'http://passporttest.ainirobot.com:8888/account/third'
        },
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
        tabindexNumChange(){
            this.tabindexNum = "-1"
        },
      async getSkillDetail () {//获取技能详情


          let res = await skillDetailApi(qs.stringify({skill_id: this.$route.query.skillId,online:this.$route.query.online}))
        if (res.data.data.code == 200) {
          // console.log(res.data.data.data)
          let data = res.data.data.data
            this.open_skill_type = data.open_skill_type
          if (data.skill_id && data.endpoint_uri_online) {
            this.settingInfo.skill_id = data.skill_id
            this.settingInfo.skill_id = data.skill_id
            this.settingInfo.endpoint_uri_online = data.endpoint_uri_online
            this.settingInfo.resource_client_id = data.resource_client_id
            if (data.resource_client_id) {
              this.settingInfo.auth_info_set = true
            }
            this.settingInfo.resource_client_secret = data.resource_client_secret
            this.settingInfo.login_uri = data.login_uri
              //兼容之前的技能，回调地址
            this.settingInfo.redirect_uri = data.redirect_uri ? data.redirect_uri : this.redirectUri()
            this.settingInfo.token = data.token
            this.settingInfo.auth_info_set = data.auth_info_set
            this.settingInfo.scope = data.scope
              for (let key in this.settingInfo) {
               this.settingInfo2[key]= this.settingInfo[key]
              }
          }
        }
      },
      isCanInput(){
        if(localStorage.getItem('onlineFlag') == '1'){
          this.local = true;
        }else{
          this.local = false;
        }
      },
        oauth () {
            this.$confirm('授权登录后，会跳转到空白页面，请自行关闭', '温馨提示', {
                confirmButtonText: '确定'
            }).then(() => {
                this.authorization()
            }).catch(() => {

                    });
        },
      async settingService () {
        this.$store.dispatch('changeR',true);

        this.$refs.setting.validate((valid) => {})


        let RegUrl = /[a-zA-z]+:\/\/[^\s]*/
        if (!RegUrl.test(this.settingInfo.endpoint_uri_online)) {
          this.$message({message: '请填写正确的部署url地址', type: 'error'})
          return
        }
        if (this.settingInfo.auth_info_set) {
          if (!this.settingInfo.resource_client_id) {
            this.$message({message: '请填写注册应用时获得的API Key', type: 'error'})
            return
          } else if (!this.settingInfo.resource_client_secret) {
            this.$message({message: '请填写meatapp上用户授权地址', type: 'error'})
            return
          } else if (!RegUrl.test(this.settingInfo.login_uri)) {
            this.$message({message: '请填写正确的url地址', type: 'error'})
            return
          } else if (!RegUrl.test(this.settingInfo.redirect_uri)) {
            this.$message({message: '请填写正确的url地址', type: 'error'})
            return
          }
         else if (!RegUrl.test(this.settingInfo.token)) {
           this.$message({message: '请填写正确的url地址', type: 'error'})
           return
         }
          else if (!this.settingInfo.scope) {
            this.$message({message: '请填写Scope权限', type: 'error'})
            return
          }

        }else{
          //this.settingInfoNull.endpoint_uri_online=this.settingInfo.endpoint_uri_online
          this.settingInfo.resource_client_id=null;
          this.settingInfo.resource_client_secret=null;
          this.settingInfo.login_uri=null;
          // this.settingInfo.redirect_uri=null;
          this.settingInfo.scope=null;

        }

        this.settingInfo.skill_id = this.$route.query.skillId
        let res = await settingSerApi(qs.stringify(this.settingInfo))
        if (res.data.code == 200) {
         this.$message({message: '配置服务成功', type: 'success'})
//          this.$router.go(-1)
//         this.settingInfo = {}
       } else if (res.data.code == 401) {
         window.location.href = '/login'
       } else {
            if (res.data.errors == {}) {
                this.$message({message: '配置服务失败', type: 'error'})
            } else {
                this.$message.error(res.data.errors.data)
            }
       }
      },
      async settingService2 () {
          this.$store.dispatch('changeR',true);
            // var reg=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
            this.$store.dispatch('changeR',true);
            // this.$refs.setting.validate((valid) => {})
            let RegUrl = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
            if (this.settingInfo2.endpoint_uri_online && !RegUrl.test(this.settingInfo2.endpoint_uri_online)) {
                this.$message({message: '请填写正确的部署url地址', type: 'error'})
                return
            }
            if (this.settingInfo2.login_uri && !RegUrl.test(this.settingInfo2.login_uri)) {
                this.$message({message: '请填写正确的授权地址', type: 'error'})
                return
            }
            if (this.settingInfo2.redirect_uri && !RegUrl.test(this.settingInfo2.redirect_uri)) {
                this.$message({message: '请填写正确的回调地址', type: 'error'})
                return
            }
            if (this.settingInfo2.token && !RegUrl.test(this.settingInfo2.token)) {
                this.$message({message: '请填写正确的token地址', type: 'error'})
                return
            }

            this.settingInfo2.skill_id = this.$route.query.skillId
            let res = await settingSerApi(qs.stringify(this.settingInfo2))
            if (res.data.code == 200) {
                this.$message({message: '配置服务成功', type: 'success'})
            } else if (res.data.code == 401) {
                window.location.href = '/login'
            } else {
                if (res.data.errors == {}) {
                    this.$message({message: '配置服务失败', type: 'error'})
                } else {
                    this.$message.error(res.data.errors.data)
                }
            }
        },

      async authorization () {
          this.$store.dispatch('changeR',true)
          this.loadingFlag = true // 保存并授权 按钮加loading
          // var reg="^((https|http|ftp|rtsp|mms)?://)"
          //     + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@
          //     + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
          //     + "|" // 允许IP和DOMAIN（域名）
          //     + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
          //     + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
          //     + "[a-z]{2,6})" // first level domain- .com or .museum
          //     + "(:[0-9]{1,4})?" // 端口- :80
          //     + "((/?)|" // a slash isn't required if there is no file name
          //     + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
            let RegUrl = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
            if (!this.settingInfo2.endpoint_uri_online || !RegUrl.test(this.settingInfo2.endpoint_uri_online)) {
                this.$message({message: '请填写正确的部署url地址', type: 'error'})
                return
            }
            if (!this.settingInfo2.resource_client_id) {
                this.$message({message: '请填写注册应用时获得的API Key', type: 'error'})
                return
            }
            if (!this.settingInfo2.resource_client_secret) {
                this.$message({message: '请填写请求密钥', type: 'error'})
                return
            }
            if (!this.settingInfo2.login_uri || !RegUrl.test(this.settingInfo2.login_uri)) {
                this.$message({message: '请填写正确的url地址', type: 'error'})
                return
            }
            if (!this.settingInfo2.redirect_uri || !RegUrl.test(this.settingInfo2.redirect_uri)) {
                this.$message({message: '请填写正确的url地址', type: 'error'})
                return
            }
            if (!this.settingInfo2.token || !RegUrl.test(this.settingInfo2.token)) {
                this.$message({message: '请填写正确的url地址', type: 'error'})
                return
            }
            //  if (!this.settingInfo2.scope) {
            //     this.$message({message: '请填写Scope权限', type: 'error'})
            //     return
            // }
          this.settingInfo2.skill_id = this.$route.query.skillId
          let res = await settingSerApi(qs.stringify(this.settingInfo2))
          if (res.data.code == 200) { //授权先保存，成功调授权接口
              this.loadingFlag = false
                let data = {
                    skill_id: this.$route.query.skillId,
                    online:  this.$route.query.online
                }

                let response = await saveAuthorizationApi(qs.stringify(data))

                if (response.data.code = 200) { // 授权跳转到第三方页面
                    let _this = this
                    this.twoMinutes = setTimeout(function () {
                        clearInterval(Vue.time) //2分后关掉定时器
                        _this.$router.push({path: '/serviceErr'+'?skillId='+_this.$route.query.skillId+'&online='+_this.$route.query.online})
                    },120000)
                    Vue.time = setInterval(function () {
                        _this.searchAccountInfo() // 调授权信息的接口
                    }, 2000)
                    this.$router.push({path: '/serviceIng'+'?skillId='+this.$route.query.skillId+'&online='+this.$route.query.online})
                    window.open(response.data.data.link_account_url,'_blank')
                    // $('#content_info').attr('src',response.data.data.link_account_url)
                    // console.log(document.getElementById("content_info").contentWindow.location.href)
                } else {
                    this.$message({message: '授权失败，请重新授权', type: 'error'})
                }

          } else if (res.data.code == 401) {
              this.loadingFlag = false
              window.location.href = '/login'
          } else {
              this.loadingFlag = false
              if (res.data.errors == {}) {
                  this.$message({message: '配置服务保存失败，请重新授权', type: 'error'})
              } else {
                  this.$message.error(res.data.errors.data)
              }
          }
        },
      async searchAccountInfo () { //查看授权信息，是否授权成功
          let data = {
              skill_id: this.$route.query.skillId,
              online:  this.$route.query.online
          }
          let res = await searchAccountInfoApi(qs.stringify(data))
          if (res.data.code == 200) {
              clearInterval(this.twoMinutes)
              clearInterval(Vue.time) //授权成功，关掉定时器
              this.$router.push({path: '/serviceSuc'+'?skillId='+this.$route.query.skillId+'&online='+this.$route.query.online})
          } else {
              // this.$message({message: '授权失败', type: 'error'})
          }
      },
    }
  }
</script>
<style  rel="stylesheet/scss" lang="scss">
  #service{
    .el-switch__core{
      height:20px;
    }
    /*.el-switch__button{*/
      /*width: 14px;*/
      /*height: 14px;*/
      /*top:0;*/
    /*}*/
    background:#fff;
    padding-top:0;
    /*height:100%;*/
    .serviceContainer{
      height: 620px;
      .el-form-item .el-form-item__label{
        padding-right:20px;
      }
      .el-form-item{
        &:nth-child(1) {
          .el-form-item__label:before{
            content: '*';
            color:#f56c6c;
            margin-right:4px;
          }
        }
      }
      /*.el-form-item .el-form-item__label:before{*/
        /*content: '*';*/
        /*color:#f56c6c;*/
        /*margin-right:4px;*/
      /*}*/
    }
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .title_2 {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      margin-left:-30px;
      border-left: 2px solid #010202;
      border-bottom: 1px solid #f5f5f5;
    }
    .el-input__inner{
     border-radius:20px;
     width: 320px;
     height: 28px;
      line-height: 28px;
   }
    button{
      margin-left:45%;
    }
    .intentSavebtn {
      width: 90px;
      height: 32px;
    }
    .intentSavebtn2 {
      width: 120px;
      height: 32px;
      i {
        margin-top: -1px;
        vertical-align: middle;
      }
    }
    .info{
      /*border-top:1px solid #eee;*/
      padding-top:20px;
      .el-form-item {
        position: relative;
        .blurIcon {
          color: #7abaf1;
          position: absolute;
          left: -18px;
        }
        .el-form-item__label{
          padding-right:20px;
        }
      }
      .el-form-item .el-form-item__label:before{
        content: '*';
        color:#f56c6c;
        margin-right:4px;
      }
    }
    #info{
      .el-form-item{
        &:last-child{
          .el-form-item__label:before{
            content: ''
          }
        }
      }

    }
    .btn_group{
      text-align: center;
      height:120px;
      line-height: 120px;
      button{
        margin-left:0;
        &:nth-child(2){
          margin-left:20px;
        }
      }
      /*.remarks {*/
        /*margin-left:10px;*/
        /*font-size: 12px;*/
        /*color: #9e9e9e;*/
      /*}*/
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/setting/SettingService.vue